import { FormNumber, FormWithLabels, Label } from '@components/form';
import { defineComponent, h } from 'vue';

export const CenterEditor = defineComponent({
    props: {
        x: { required: true, type: Number },
        y: { required: true, type: Number },
        z: { required: true, type: Number },
    },

    emits: {
        'update:x': (x: number) => true,
        'update:y': (x: number) => true,
        'update:z': (x: number) => true,
    },

    render() {
        return h(FormWithLabels, {
            gap: 'tight',
            width: '2em',
        }, () => [
            h(Label, null, {
                label: () => h('span', 'X'),
                input: () => h(FormNumber, {
                    change: true,
                    value: this.x,
                    'onUpdate:value': (x) => this.$emit('update:x', x),
                }),
            }),

            h(Label, null, {
                label: () => h('span', 'Y'),
                input: () => h(FormNumber, {
                    change: true,
                    value: this.y,
                    'onUpdate:value': (x) => this.$emit('update:y', x),
                }),
            }),

            h(Label, null, {
                label: () => h('span', 'Z'),
                input: () => h(FormNumber, {
                    change: true,
                    value: this.z,
                    'onUpdate:value': (x) => this.$emit('update:z', x),
                }),
            }),
        ]);
    }
});
